// 'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { PopoverHeader, PopoverBody, PopoverFooter } from 'foundations-components/transitional/components/Popover';
import { forwardRef, useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentPreviewForm = /*#__PURE__*/forwardRef(({
  previewTitle,
  previewDescription,
  onCancel,
  onConfirm
}, ref) => {
  const [title, setTitle] = useState(previewTitle);
  const [description, setDescription] = useState(previewDescription);
  const cancelOrConfirmKeys = useCallback(e => {
    switch (e.key) {
      case 'Escape':
        {
          e.preventDefault();
          onCancel();
          return;
        }
      case 'Enter':
        {
          e.preventDefault();
          onConfirm({
            title,
            desc: description
          });
          return;
        }
      default:
        return;
    }
  }, [description, onCancel, onConfirm, title]);
  const inputHasNotChanged = title === previewTitle && description === previewDescription;
  const disabled = title === '' || inputHasNotChanged;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      width: 300
    },
    ref: ref,
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      children: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.title"
        })
      })
    }), /*#__PURE__*/_jsxs(PopoverBody, {
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.previewTitle"
        }),
        paddingBlockStart: "0",
        children: /*#__PURE__*/_jsx(TextInput, {
          onChange: ({
            target: {
              value
            }
          }) => {
            setTitle(value);
          },
          onKeyDown: cancelOrConfirmKeys,
          value: title
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.previewDescription"
        }),
        paddingBlockStart: "0",
        children: /*#__PURE__*/_jsx(TextInput, {
          onChange: ({
            target: {
              value
            }
          }) => {
            setDescription(value);
          },
          onKeyDown: cancelOrConfirmKeys,
          value: description
        })
      })]
    }), /*#__PURE__*/_jsxs(PopoverFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        size: "small",
        onClick: () => onConfirm({
          title,
          desc: description
        }),
        disabled: disabled,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.save"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "small",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.documents.editPopover.cancel"
        })
      })]
    })]
  });
});
export default DocumentPreviewForm;